/* One size choice for the complete set. The artwork renderer owns geometry. */
(function (root) {
  'use strict';
  function create(options) {
    const { root: host, style, renderer, rows, input, relayout, changed, update, getScales, setScales, busy } = options;
    const panel = host.querySelector('#groomsman-adjustments'), controls = host.querySelector('#groomsman-size-controls');
    const reset = host.querySelector('#groomsman-size-reset'), fit = host.querySelector('#groomsman-size-fit');
    let signature = '', fitScale = 1, designs = [];
    const fields = options.fields || [
      ...(style === 'divided-initials' ? [] : [['name', 'Name size']]),
      ...(['side-monogram', 'split-monogram', 'divided-initials'].includes(style) ? [['initials', 'Initial size']] : []),
      ...(['tux', 'bow-tie', 'mountain'].includes(style) ? [['icon', { tux: 'Tuxedo size', 'bow-tie': 'Bow tie size', mountain: 'Mountain size' }[style]]] : []),
      ['role', 'Role size'], ['date', 'Date size'],
    ];
    const scales = () => Object.fromEntries(fields.map(([key]) => [key, getScales()?.[key] ?? 1]));
    const active = () => Object.values(scales()).some(value => value !== 1);
    const currentSignature = () => JSON.stringify({ scales: scales(), rows: rows().map(row => [input(row), !!row.design, row.issue || '']) });
    function rememberCurrent() {
      signature = currentSignature();
      designs = rows().map(row => row.design);
    }
    function preserveCurrent() {
      rememberCurrent();
      fitScale = rows().find(row => row.design?.adjustments)?.design.adjustments.fitScale || 1;
    }
    function apply() {
      const next = currentSignature();
      // A field event can replace adjusted geometry while its normalized text
      // stays the same (for example, a trailing space). Reapply to new designs.
      if (next === signature && rows().length === designs.length && rows().every((row, index) => row.design === designs[index])) return;
      rememberCurrent(); fitScale = 1;
      const valid = rows().filter(row => row.design && !row.issue);
      if (!valid.length) return;
      try {
        const result = renderer.createDesignSet(valid.map(input), { scales: scales() });
        valid.forEach((row, index) => { row.design = result.designs[index]; row.issue = renderer.validate(row.design).join(' '); });
        fitScale = result.fitScale;
      } catch (cause) {
        for (const row of valid) { row.design = null; row.issue = cause.message || 'These sizes could not be applied. Reset sizes and try again.'; }
      }
      rememberCurrent();
    }
    function render() {
      if (!panel) return;
      panel.hidden = false;
      for (const [key] of fields) {
        const control = host.querySelector('#groomsman-size-' + key), value = Math.round(scales()[key] * 100);
        control.value = value; control.disabled = busy();
        host.querySelector('#groomsman-size-' + key + '-value').textContent = value + '%';
        control.setAttribute('aria-valuetext', value + ' percent');
      }
      reset.disabled = busy() || !active();
      fit.hidden = !(fitScale < .999);
    }
    function change(values) {
      if (busy()) return;
      setScales(values); signature = ''; designs = [];
      rows().forEach(relayout); changed(); update();
    }
    if (panel && controls && renderer.createDesignSet) {
      controls.replaceChildren();
      for (const [key, title] of fields) {
        const wrap = document.createElement('div'); wrap.className = 'groomsman-size-control';
        const line = document.createElement('div'); line.className = 'groomsman-size-label';
        const label = document.createElement('label'); label.htmlFor = 'groomsman-size-' + key; label.textContent = title;
        const output = document.createElement('output'); output.id = label.htmlFor + '-value'; output.htmlFor = label.htmlFor;
        const control = document.createElement('input'); control.type = 'range'; control.id = label.htmlFor;
        control.min = '50'; control.max = '150'; control.step = '5'; control.value = '100';
        control.setAttribute('aria-describedby', 'groomsman-adjustments-help');
        control.addEventListener('input', () => change({ ...scales(), [key]: Number(control.value) / 100 }));
        line.append(label, output); wrap.append(line, control); controls.append(wrap);
      }
      reset.addEventListener('click', () => change({}));
    }
    return Object.freeze({ apply, render: () => { if (renderer.createDesignSet) render(); }, preserveCurrent, get fitScale() { return fitScale; } });
  }
  root.JEGroomsmanSizing = Object.freeze({ create });
})(typeof globalThis !== 'undefined' ? globalThis : this);
